import { render, staticRenderFns } from "./MuvekkilForm.vue?vue&type=template&id=602f48a2"
import script from "./MuvekkilForm.vue?vue&type=script&lang=ts"
export * from "./MuvekkilForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports